"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LogoJMM = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ThemeProvider = require("../../provider/ThemeProvider");

var _core = require("@material-ui/core/");

var _jobmatch = _interopRequireDefault(require("./jobmatch.svg"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * The JOBMATCH.ME logo main component
 *
 * @param {logoVariant} variant The logos variant
 * @param {logoSizes}   size    The logos size
 *
 **/
var LogoJMM = function LogoJMM(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'text' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'responsive' : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100' : _ref$height,
      globalThemeVariant = _ref.globalThemeVariant,
      _ref$pointer = _ref.pointer,
      pointer = _ref$pointer === void 0 ? false : _ref$pointer;
  // Logo width defenition
  var realWidth = size === 'responsive' ? '100%' : size === 'small' ? '100' : size === 'middle' ? '200' : size;

  if (size === 'exact') {
    realWidth = "".concat(width);
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Box, {
    style: {
      cursor: pointer ? 'pointer' : 'none',
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      width: '100%'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: _jobmatch.default,
      alt: "Job Match",
      style: {
        maxWidth: realWidth,
        maxHeight: '100%'
      }
    })
  });
};

exports.LogoJMM = LogoJMM;

var _default = /*#__PURE__*/(0, _react.memo)((0, _ThemeProvider.withThemeVariant)(LogoJMM));

exports.default = _default;